import { Stack, Typography } from "@mui/material";
import * as numbers from "common/numbers";
import { useSelector } from "react-redux";
import * as towerPricingSelectors from "store/selectors/pricing/tower/towerPricingSelectors";

const LabelledData = ({ label, data }) =>
  data == null ? (
    <></>
  ) : (
    <Stack>
      <Typography variant={"overline"} sx={{ lineHeight: "1rem" }}>
        {label}
      </Typography>
      <Typography variant={"subtitle2"}>{data}</Typography>
    </Stack>
  );

const TowerDiagram = ({ tower }) => {
  const border = "1px solid gainsboro";
  const dim = "rgba(0, 0, 0, 0.04);";

  return (
    <Stack sx={{ borderRadius: "1rem", border: border }}>
      {tower.map((layer, layerIndex) => (
        <Stack key={layerIndex} direction={"row"}>
          {layer.shares.map((share, shareIndex) => (
            <Stack
              key={shareIndex}
              flexGrow={1}
              gap={0.5}
              sx={{
                padding: "1rem",
                borderBottom: layerIndex === tower.length - 1 ? null : border,
                borderLeft: shareIndex > 0 ? border : null,
                background: layer.attachment === 0 ? dim : null,
                borderBottomLeftRadius:
                  layer.attachment === 0 && shareIndex === 0 ? "0.9375rem" : 0,
                borderBottomRightRadius:
                  layer.attachment === 0 &&
                  shareIndex === layer.shares.length - 1
                    ? "0.9375rem"
                    : 0,
              }}
            >
              <Stack
                direction={"row"}
                sx={{
                  flexWrap: "wrap",
                  flexShrink: 0,
                  gap: "8px 32px",
                }}
              >
                <LabelledData label={"Carrier"} data={share.carrier} />
                <LabelledData
                  label={"Limit"}
                  data={numbers.currencyFormat(
                    share?.shareOfLimit ?? layer.limit
                  )}
                />
                <LabelledData label={"Cover"} data={share.coverage} />
              </Stack>
            </Stack>
          ))}
        </Stack>
      ))}
    </Stack>
  );
};

const Structure = () => {
  const tower = useSelector(towerPricingSelectors.getInvertedTower);
  const hasTower = (tower ?? []).length > 0;
  return hasTower ? <TowerDiagram tower={tower} /> : <></>;
};

export default Structure;
